module.exports = __webpack_public_path__ + "static/media/Youtube.33461697.png";